/*** LOADER ***/

import { CLASSPREFIX } from "../config/constants"

export default class Loader {
    selector: string;
    target: HTMLElement;
    visibility: 'hide' | 'show';

    constructor(selector: string) {
        this.selector = selector;
        this.target = document.querySelector(selector)
    }

    setVisibility(visibility: 'hide' | 'show') {
        this.visibility = visibility;
        switch (visibility) {
            case 'hide':
                this.target.classList.add(`${CLASSPREFIX}-loader--hide`)
                break;

            case 'show':
                this.target.classList.remove(`${CLASSPREFIX}-loader--hide`)
                break;
        }
    }
}